import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';

import { ListModel } from '../../model/list.model';
import { ListValueModel } from '../../model/list-value.model';
import { ListValueService } from '../../service/list-value.service';

@Component({
  selector: 'app-list-value-filter-modal',
  templateUrl: './list-value-filter-modal.component.html',
  styles: [`.center { align-content: center; text-align: center; }`],
})
export class ListValueFilterModalComponent implements OnInit {
	@Output() listValueIds = new EventEmitter<[number[], any]>();
  @Input() selectedListIds: any[] = [];

  display = false;
  loading = true;
  showId = false;
  count = 0;

  selectedListValues: any[] = [];
  listValues: ListValueModel[] = [];
  list = new ListModel();
  lastEvent: any = {};

  constructor(
    private listValueService: ListValueService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {}

  lazy(e) {
    this.loading = true;
    this.listValues = [];
    this.lastEvent = e || {};

    const { filters, rows, first } = this.lastEvent;

    const end = rows || 50;
    const init = first || 0;
    const id = filters && filters["id"] ? filters["id"].value : null;
    const description = filters && filters["description"] ? filters["description"].value : null;

    if (!this.list || !this.list.id) return console.error('No list to find');

    this.listValueService.getAll({
      init, end, id, description,
      list_id: this.list.id,
    }).pipe(take(1))
    .subscribe(({ rows, count }) => {
      this.cdRef.markForCheck();
      this.listValues = rows;
      this.loading = false;
      this.count = count;
    });
  }

  onShow(listId, list, index, response) {
    this.loadSelectedLists(response);

    if (list) this.list = list;

    this.list.index = index;
    this.list.id = listId;

    if(listId) {
      this.lazy(this.lastEvent);
      this.display = true;
    }
  }

  loadSelectedLists(response) {
    const validation = response && response.length ? response : [];

    this.selectedListValues = validation || [];
    this.selectedListIds = [];

    if (validation && validation.length) {
      for (const list of validation) {
        this.selectedListIds[list.id] = true;
      }
    }
  }

  onHide() {
    this.list = new ListModel();
    this.display = false;

    // fix invalid list filter using last count
    this.lastEvent = { first: 0, rows: 50 };
  }

  onSelect(list, add: boolean = false) {
    const index = this.selectedListValues ? this.selectedListValues.findIndex(l => l.id == list.id) : -1;

    if (!list || !list.id) {
      console.error('Error, List Not Found. List', list);
    }

    if (add && index == -1) {
      this.selectedListValues.push(list);
    } else if (!add && index != -1) {
      this.selectedListValues.splice(index, 1);
    } else if (index != 0) {
      console.error('Error, List Not Found. Index', index);
    }

    this.listValueIds.emit([
      this.selectedListValues, 
      this.list,
    ]);
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/list-value-filter-modal/list-value-filter-modal.component.ts